var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart range_input",
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.currentValue,
            expression: "currentValue",
            modifiers: {
              number: true,
            },
          },
        ],
        attrs: {
          type: "range",
          name: _vm.name,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          "aria-valuemin": _vm.min,
          "aria-valuemax": _vm.max,
          "aria-valuenow": _vm.currentValue,
        },
        domProps: {
          value: _vm.currentValue,
        },
        on: {
          __r: function __r($event) {
            _vm.currentValue = _vm._n($event.target.value)
          },
          blur: function blur($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "output",
        {
          attrs: {
            for: "fader",
          },
        },
        [
          _c(
            "translate",
            {
              attrs: {
                "translate-params": {
                  myValue: _vm.currentValue,
                  max: _vm.max,
                },
              },
            },
            [_vm._v("\n            %{myValue} von %{max}\n        ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }